/**
 * @generated SignedSource<<55fbcbff2c6c0cc116976db95d5bea55>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useEditorCollaboratorsFragment_content$data = Result<{
  readonly id: string | null;
  readonly space: {
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly id: string | null;
  } | null;
  readonly status: string | null;
  readonly " $fragmentType": "useEditorCollaboratorsFragment_content";
}, unknown>;
export type useEditorCollaboratorsFragment_content$key = {
  readonly " $data"?: useEditorCollaboratorsFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorCollaboratorsFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEditorCollaboratorsFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "concreteType": "SpaceUserMetadata",
          "kind": "LinkedField",
          "name": "currentUser",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isAdmin"
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "3cfb679602f749a1880ca81ecb54323d";

export default node;
